import React from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";
import { useAppSelector } from "store/index";

import Filter from "components/global/Filter/Filter";

import gridIcon from "assets/icons/grid-icon.svg";

interface Props {
  handleUpdateGeo?: (e: { value: string | number; label: string }[]) => void;
  selectedGeo?: { value: string | number; label: string }[];
  handleUpdateCurrency?: (
    e: { value: string | number; label: string }[]
  ) => void;
  selectedCurrency?: { value: string | number; label: string }[];
  handleApply: () => void;
  type: string;
  stepValue?: string;
  handleStep?: (e: string) => void;
  depValue?: string;
  handleDep?: (e: string) => void;
}
const PointsFilter: React.FC<Props> = ({
  handleUpdateGeo,
  selectedGeo,
  handleUpdateCurrency,
  selectedCurrency,
  handleApply,
  type,
  stepValue,
  handleStep,
  depValue,
  handleDep,
}) => {
  const { t } = useTranslation();

  const currenciesList = useAppSelector((store) => store.settings.currencies);
  const geoList = useAppSelector((state) => state.settings.geoList);

  const handleApplyGeo = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean
  ) => {
    if (handleUpdateGeo && selectedGeo) handleUpdateGeo(isDelete ? e : [...e]);
  };
  const handleApplyCurrency = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean
  ) => {
    if (handleUpdateCurrency && selectedCurrency)
      handleUpdateCurrency(isDelete ? e : [...selectedCurrency, ...e]);
  };

  const handleClearFilters = () => {
    if (handleUpdateGeo) handleUpdateGeo([]);
    if (handleUpdateCurrency) handleUpdateCurrency([]);
    if (handleDep) handleDep("");
    if (handleStep) handleStep("");
    handleApply();
  };

  const handleApplyFilters = () => {
    handleApply();
  };

  const getItems = () => {
    switch (type) {
      case "bet":
        return [
          {
            type: FilterItemTypes.input,
            title: t("numberOfStep"),
            boxTitle: t("numberOfStep"),
            icon: gridIcon,
            inputValue: stepValue,
            setInputValue: handleStep,
          },
          {
            type: FilterItemTypes.multiselect,
            title: t("currency"),
            boxTitle: t("currency"),
            icon: gridIcon,
            itemsArray:
              currenciesList?.map((el) => {
                return {
                  label: el,
                  value: el,
                };
              }) ?? [],
            activeItems: selectedCurrency,
            handleApply: handleApplyCurrency,
            disabled: currenciesList.length === 0,
          },
        ];
      case "deposit":
        return [
          {
            type: FilterItemTypes.input,
            title: t("numberOfDeposit"),
            boxTitle: t("numberOfDeposit"),
            icon: gridIcon,
            inputValue: depValue,
            setInputValue: handleDep,
          },
          {
            type: FilterItemTypes.multiselect,
            title: t("currency"),
            boxTitle: t("currency"),
            icon: gridIcon,
            itemsArray:
              currenciesList?.map((el) => {
                return {
                  label: el,
                  value: el,
                };
              }) ?? [],
            activeItems: selectedCurrency,
            handleApply: handleApplyCurrency,
            disabled: currenciesList.length === 0,
          },
        ];
      case "signUp":
        return [
          {
            type: FilterItemTypes.multiselect,
            title: t("geo"),
            boxTitle: t("geo"),
            icon: gridIcon,
            itemsArray:
              geoList?.map((el) => {
                return {
                  label: el,
                  value: el,
                };
              }) ?? [],
            activeItems: selectedGeo,
            handleApply: handleApplyGeo,
            disabled: geoList.length === 0,
          },
        ];
      case "wager":
        return [
          {
            type: FilterItemTypes.multiselect,
            title: t("currency"),
            boxTitle: t("currency"),
            icon: gridIcon,
            itemsArray:
              currenciesList?.map((el) => ({
                label: el,
                value: el,
              })) ?? [],
            activeItems: selectedCurrency,
            handleApply: handleApplyCurrency,
            disabled: currenciesList.length === 0,
          },
        ];

      default:
        return [];
    }
  };

  return (
    <Filter
      handleClear={handleClearFilters}
      handleApply={handleApplyFilters}
      filterItems={getItems()}
    />
  );
};

export default PointsFilter;
